import { render, staticRenderFns } from "./ReportModal.vue?vue&type=template&id=36d0ff0a&"
import script from "./ReportModal.vue?vue&type=script&lang=js&"
export * from "./ReportModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports